import { Component, Input, OnInit } from '@angular/core';
import {AbstractControl, FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss']
})
export class AppFormErrorComponent implements OnInit {
  @Input() id!: string;
  @Input() formGroup!: FormGroup;
  @Input() controlName: string = '';
  @Input() isModalReport: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  get control(): AbstractControl | null {
    return this.formGroup.get(this.controlName);
  }

}
